import { useState } from 'react';
import {
    Button,
    ButtonMenu,
    Calendar,
    Card,
    Checkbox,
    DatePicker,
    TimePicker,
    FAQAccordion,
    GridCards,
    Header,
    HeroSection,
    InstructorSection,
    Menu,
    Modal,
    RadioButton,
    Select,
    Switch,
    Table,
} from '../../components';
import './TestPage.scss';
import { Medal, Flame, Users } from 'lucide-react';

function TestPage() {
    const [modalOpen, setModalOpen] = useState(false);
    const [checkboxVal, setCheckboxVal] = useState(false);
    const [switchVal, setSwitchVal] = useState(true);
    const [radioVal, setRadioVal] = useState('option1');
    const [selectVal, setSelectVal] = useState('');
    const [dateVal, setDateVal] = useState(null);
    const [timeVal, setTimeVal] = useState('17:00');
    const [calendarDate, setCalendarDate] = useState(new Date());

    const menuItems = [
        { label: 'Profil', onClick: () => { } },
        { label: 'Nastavenia', onClick: () => { } },
        { divider: true },
        { label: 'Odhlásiť sa', onClick: () => { }, danger: true },
    ];

    const buttonMenuItems = [
        { label: 'Exportovať PDF', onClick: () => { } },
        { label: 'Exportovať CSV', onClick: () => { } },
        { divider: true },
        { label: 'Tlačiť', onClick: () => { } },
    ];

    const selectOptions = [
        { label: 'Začiatočníci', value: 'beginners' },
        { label: 'Pokročilí', value: 'advanced' },
        { label: 'Deti', value: 'kids' },
        { label: 'Profesionáli', value: 'pro', disabled: true },
    ];

    return (
        <>
            <main className="test-page">
                <h1 className="test-page__title">Komponenty – Test Page</h1>

                {/* Buttons */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Button</h2>
                    <div className="test-page__row">
                        <Button variant="primary">Primary</Button>
                        <Button variant="outline">Outline</Button>
                        <Button variant="ghost">Ghost</Button>
                        <Button variant="primary" disabled>Disabled</Button>
                    </div>
                    <div className="test-page__row">
                        <Button variant="primary" size="sm">Small</Button>
                        <Button variant="primary">Default</Button>
                        <Button variant="primary" size="lg">Large</Button>
                    </div>
                </section>

                {/* ButtonMenu */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">ButtonMenu</h2>
                    <div className="test-page__row">
                        <ButtonMenu label="Exportovať" items={buttonMenuItems} variant="primary" />
                        <ButtonMenu label="Možnosti" items={buttonMenuItems} variant="outline" align="right" />
                    </div>
                </section>

                {/* Menu */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Menu (Dropdown)</h2>
                    <div className="test-page__row">
                        <Menu
                            trigger={<Button variant="outline">Otvoriť menu</Button>}
                            items={menuItems}
                        />
                        <Menu
                            trigger={<Button variant="ghost">Menu vpravo</Button>}
                            items={menuItems}
                            align="right"
                        />
                    </div>
                </section>

                {/* Cards */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Card</h2>
                    <div className="test-page__grid">
                        <Card>
                            <Card.Header>
                                <Card.Title>Základná karta</Card.Title>
                                <Card.Subtitle>Default variant</Card.Subtitle>
                            </Card.Header>
                            <Card.Body>
                                Toto je obsah základnej karty. Využíva zaoblenie, tieň a padding z premenných.
                            </Card.Body>
                            <Card.Footer>
                                <Button variant="primary" size="sm">Akcia</Button>
                            </Card.Footer>
                        </Card>

                        <Card variant="highlighted">
                            <Card.Header>
                                <Card.Title>Zvýraznená karta</Card.Title>
                                <Card.Subtitle>variant="highlighted"</Card.Subtitle>
                            </Card.Header>
                            <Card.Body>
                                Karta s orámovaním v primary farbe – vhodná pre "Najobľúbenejšie" a pod.
                            </Card.Body>
                        </Card>

                        <Card variant="flat">
                            <Card.Header>
                                <Card.Title>Plochá karta</Card.Title>
                                <Card.Subtitle>variant="flat"</Card.Subtitle>
                            </Card.Header>
                            <Card.Body>
                                Karta bez tieňa, len s jemným rámčekom.
                            </Card.Body>
                        </Card>
                    </div>
                </section>

                {/* Select */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Select</h2>
                    <div className="test-page__form-group">
                        <Select
                            label="Vyber skupinu"
                            options={selectOptions}
                            value={selectVal}
                            onChange={setSelectVal}
                            placeholder="Zvoľ kurz..."
                        />
                    </div>
                    <div className="test-page__form-group">
                        <Select
                            label="Disabled select"
                            options={selectOptions}
                            value=""
                            disabled
                        />
                    </div>
                </section>

                {/* Checkbox */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Checkbox</h2>
                    <div className="test-page__row">
                        <Checkbox
                            checked={checkboxVal}
                            onChange={setCheckboxVal}
                            label="Súhlasím s podmienkami"
                        />
                    </div>
                    <div className="test-page__row">
                        <Checkbox checked disabled label="Disabled checked" />
                        <Checkbox checked={false} disabled label="Disabled unchecked" />
                    </div>
                </section>

                {/* Switch */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Switch</h2>
                    <div className="test-page__row">
                        <Switch
                            checked={switchVal}
                            onChange={setSwitchVal}
                            label="Notifikácie"
                        />
                    </div>
                    <div className="test-page__row">
                        <Switch checked disabled label="Disabled ON" />
                        <Switch checked={false} disabled label="Disabled OFF" />
                    </div>
                </section>

                {/* RadioButton */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">RadioButton</h2>
                    <RadioButton.Group label="Vyber úroveň:" direction="vertical">
                        <RadioButton
                            name="level"
                            value="option1"
                            checked={radioVal === 'option1'}
                            onChange={setRadioVal}
                            label="Začiatočník"
                        />
                        <RadioButton
                            name="level"
                            value="option2"
                            checked={radioVal === 'option2'}
                            onChange={setRadioVal}
                            label="Pokročilý"
                        />
                        <RadioButton
                            name="level"
                            value="option3"
                            checked={radioVal === 'option3'}
                            onChange={setRadioVal}
                            label="Profesionál"
                        />
                    </RadioButton.Group>

                    <div style={{ marginTop: '1rem' }}>
                        <RadioButton.Group label="Horizontálne:" direction="horizontal">
                            <RadioButton
                                name="plan"
                                value="monthly"
                                checked={radioVal === 'monthly'}
                                onChange={setRadioVal}
                                label="Mesačne"
                            />
                            <RadioButton
                                name="plan"
                                value="yearly"
                                checked={radioVal === 'yearly'}
                                onChange={setRadioVal}
                                label="Ročne"
                            />
                        </RadioButton.Group>
                    </div>
                </section>

                {/* Modal */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Modal</h2>
                    <Button variant="primary" onClick={() => setModalOpen(true)}>
                        Otvoriť Modal
                    </Button>

                    <Modal
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                        title="Potvrdenie registrácie"
                        footer={
                            <>
                                <Button variant="ghost" onClick={() => setModalOpen(false)}>Zrušiť</Button>
                                <Button variant="primary" onClick={() => setModalOpen(false)}>Potvrdiť</Button>
                            </>
                        }
                    >
                        <p>Naozaj sa chceš zaregistrovať na kurz Capoeira pre začiatočníkov?</p>
                        <p style={{ marginTop: '0.5rem', color: '#5A6A7A' }}>
                            Po potvrdení ti príde email s ďalšími inštrukciami.
                        </p>
                    </Modal>
                </section>

                {/* Table */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Table</h2>
                    <Table
                        columns={[
                            { key: 'name', label: 'Meno', width: '25%' },
                            { key: 'email', label: 'Email' },
                            { key: 'group', label: 'Skupina' },
                            { key: 'level', label: 'Úroveň' },
                            { key: 'joined', label: 'Registrácia', render: (val) => new Date(val).toLocaleDateString('sk-SK') },
                        ]}
                        data={[
                            { id: 1, name: 'Jano Kováč', email: 'jano@example.com', group: 'Začiatočníci', level: 'Cordao Crua', joined: '2024-01-15' },
                            { id: 2, name: 'Petra Nováková', email: 'petra@example.com', group: 'Pokročilí', level: 'Cordao Verde', joined: '2023-06-20' },
                            { id: 3, name: 'Marek Horký', email: 'marek@example.com', group: 'Začiatočníci', level: 'Cordao Crua', joined: '2024-03-10' },
                            { id: 4, name: 'Lucia Kráľová', email: 'lucia@example.com', group: 'Deti', level: 'Cordao Crua', joined: '2024-05-01' },
                            { id: 5, name: 'Tomáš Veselý', email: 'tomas@example.com', group: 'Pokročilí', level: 'Cordao Amarela', joined: '2022-11-08' },
                            { id: 6, name: 'Eva Čierna', email: 'eva@example.com', group: 'Začiatočníci', level: 'Cordao Crua', joined: '2024-07-22' },
                            { id: 7, name: 'Adam Bielok', email: 'adam@example.com', group: 'Pokročilí', level: 'Cordao Azul', joined: '2021-09-15' },
                            { id: 8, name: 'Zuzana Malá', email: 'zuzana@example.com', group: 'Deti', level: 'Cordao Crua', joined: '2024-02-14' },
                            { id: 9, name: 'Martin Veľký', email: 'martin@example.com', group: 'Začiatočníci', level: 'Cordao Crua', joined: '2024-08-30' },
                            { id: 10, name: 'Katarína Rybárová', email: 'katka@example.com', group: 'Pokročilí', level: 'Cordao Verde', joined: '2023-04-12' },
                            { id: 11, name: 'Peter Holý', email: 'peter@example.com', group: 'Začiatočníci', level: 'Cordao Crua', joined: '2024-09-05' },
                            { id: 12, name: 'Mária Slováková', email: 'maria@example.com', group: 'Deti', level: 'Cordao Crua', joined: '2024-04-18' },
                        ]}
                        searchable
                        sortable
                        paginated
                        selectable
                        pageSize={5}
                    />
                </section>

                {/* DatePicker */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">DatePicker</h2>
                    <div className="test-page__form-group">
                        <DatePicker
                            label="Dátum tréningu"
                            value={dateVal}
                            onChange={setDateVal}
                            placeholder="Vyber dátum..."
                        />
                    </div>
                    <div className="test-page__form-group">
                        <DatePicker
                            label="S min/max obmedzením"
                            value={dateVal}
                            onChange={setDateVal}
                            minDate={new Date(2024, 0, 1)}
                            maxDate={new Date(2026, 11, 31)}
                        />
                    </div>
                </section>

                {/* TimePicker */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">TimePicker</h2>
                    <div className="test-page__form-group">
                        <TimePicker
                            label="Čas tréningu"
                            value={timeVal}
                            onChange={setTimeVal}
                            placeholder="Vyber čas..."
                        />
                    </div>
                </section>

                {/* Calendar */}
                <section className="test-page__section">
                    <h2 className="test-page__subtitle">Calendar</h2>
                    <Calendar
                        selectedDate={calendarDate}
                        onDateSelect={setCalendarDate}
                        events={[
                            { date: new Date(), title: 'Tréning začiatočníci', timeFrom: '18:00', timeTo: '19:00', color: '#8d3c09' },
                            { date: new Date(), title: 'Roda', timeFrom: '20:00', timeTo: '21:00', color: '#F5A623' },
                            { date: new Date(new Date().setDate(new Date().getDate() + 2)), title: 'Workshop', timeFrom: '10:00', timeTo: '12:00' },
                            { date: new Date(new Date().setDate(new Date().getDate() + 5)), title: 'Pokročilí', timeFrom: '19:00', timeTo: '20:00' },
                            { date: new Date(new Date().setDate(new Date().getDate() + 7)), title: 'Batizado', timeFrom: '14:00', timeTo: '16:00', color: '#EF4444' },
                        ]}
                    />
                </section>
            </main>

            {/* HeroSection */}
            <HeroSection
                badge="Bratislava, Slovakia"
                title="CAPOEIRA BRATISLAVA"
                subtitle="Objavte umenie brazílskej bojovej hry"
                actions={
                    <>
                        <Button variant="primary" size="lg">
                            Zaregistrujte sa a skúste bezplatnú hodinu →
                        </Button>
                        <Button variant="outline" size="lg" style={{ borderColor: '#fff', color: '#fff' }}>
                            ▷ Zistiť viac
                        </Button>
                    </>
                }
                stats={[
                    { value: '18+', label: 'Years' },
                    { value: '500+', label: 'Students' },
                    { value: '3', label: 'Masters' },
                ]}
                backgroundImage="/pictures/hero_image.jpg"
            />

            {/* InstructorSection */}
            <InstructorSection
                tag="Nositeľ Radu Rio Branco"
                tagIcon={<Medal />}
                title1="SPOZNAJTE"
                title2="INSTRUKTOR FOGO"
                description={`Martin "Fogo" Halasz vedie ABADÁ-Capoeira na Slovensku už viac ako 20 rokov. Jeho filozofia výučby Telo & Myseľ & Spoločnosť formuje novú generáciu capoeiristov.`}
                benefits={[
                    { icon: <Medal />, text: 'RAD RIO BRANCO', description: 'Vyznamenaný brazílskou vládou za šírenie kultúry' },
                    { icon: <Flame />, text: '20+ ROKOV SKÚSENOSTÍ', description: 'Vedúca osobnosť ABADÁ-Capoeira na Slovensku' },
                    { icon: <Users />, text: 'PRE VŠETKÝCH', description: 'Hodiny pre deti, dospelých a všetky úrovne' },
                ]}
                actions={<Button variant="primary">Zistiť viac</Button>}
                image="/pictures/Capoeira_Master.jpg"
                imageAlt="Inštruktor Capoeiry"
                citation={['"Capoeira é de todo mundo"', '– Capoeira je pre každého']}
            />

            {/* InstructorSection – reversed */}
            <InstructorSection
                tag="Metóda"
                title1="Tradícia spojená"
                title2="s moderným prístupom"
                description="Kombinujeme tradičné brazílske techniky s modernou metodológiou tréningu, aby bola Capoeira prístupná každému."
                benefits={[
                    { icon: '💪', text: 'Zlepšenie kondície a flexibility' },
                    { icon: '🧠', text: 'Rozvoj koordinácie a reflexov' },
                    { icon: '🤝', text: 'Budovanie komunity' },
                ]}
                reversed
            />

            {/* GridCards – Cenník */}
            <GridCards
                tag="Cenník"
                title="Vyber si svoj plán"
                subtitle="Flexibilné členstvá pre každú úroveň"
                cards={[
                    {
                        title: 'Základné',
                        price: '29€',
                        period: '/ mesiac',
                        features: ['2x týždenne tréning', 'Prístup do online komunity', 'Základné materiály'],
                        action: <Button variant="outline" style={{ width: '100%' }}>Vybrať</Button>,
                    },
                    {
                        title: 'Obľúbené',
                        price: '49€',
                        period: '/ mesiac',
                        highlighted: true,
                        badge: 'Najobľúbenejšie',
                        features: ['Neobmedzené tréningy', 'Prístup do online komunity', 'Video tutoriály', 'Hudobné workshopy', 'Prioritná podpora'],
                        action: <Button variant="primary" style={{ width: '100%' }}>Vybrať</Button>,
                    },
                    {
                        title: 'Premium',
                        price: '79€',
                        period: '/ mesiac',
                        features: ['Všetko z Obľúbené', 'Privátne lekcie 1x mesačne', 'Medzinárodné eventy', 'VIP prístup'],
                        action: <Button variant="outline" style={{ width: '100%' }}>Vybrať</Button>,
                    },
                ]}
            />

            {/* FAQAccordion */}
            <FAQAccordion
                tag="FAQ"
                title="Často kladené otázky"
                items={[
                    {
                        question: 'Potrebujem predchádzajúce skúsenosti s bojovým umením?',
                        answer: 'Nie, naše kurzy sú vhodné pre úplných začiatočníkov. Inštruktori vás prevedú základmi krok za krokom.',
                    },
                    {
                        question: 'Aké vybavenie potrebujem?',
                        answer: 'Na začiatok stačí pohodlné športové oblečenie. Špeciálne nohavice abadá si môžete zakúpiť neskôr u nás.',
                    },
                    {
                        question: 'Koľko trvá jeden tréning?',
                        answer: 'Štandardný tréning trvá 60-90 minút vrátane rozcvičky, technickej časti a rody (hry v kruhu).',
                    },
                    {
                        question: 'Môžem si vyskúšať prvý tréning zadarmo?',
                        answer: 'Áno! Prvý tréning je vždy zadarmo a nezáväzný. Stačí sa registrovať online alebo prísť priamo.',
                    },
                    {
                        question: 'Je Capoeira vhodná pre deti?',
                        answer: 'Určite áno. Máme špeciálne skupiny pre deti od 5 rokov, kde sa učia hravou formou.',
                    },
                ]}
            />
        </>
    );
}

export default TestPage;
